import ResponsiveMenuIcon from '../responsiveMenuIcon'
import Logo from '../../../assets/images/logo.svg'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import NavigationHelper from '../../../utils/navigation'

const ResponsivePageTitle = () => {
    return (
        <div className="responsive-page-title">
            <ResponsiveMenuIcon/>
            <Link to={NavigationHelper.getLocalizedPath(routes.resources.paths)}><img width="150" height="32" src={Logo} alt="Pinghome"/></Link>
        </div>
    )
}

export default ResponsivePageTitle
